import PromotionLink from 'components/PromotionLink'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { cdnImageUrl } from 'helpers/image'
import React, { FC } from 'react'
import { useService } from 'services/utils/context'
import { usePremiumPageStore } from 'store/context'
import styled from 'styled-components'
import HorizontalSlider from 'uiComponents/molecules/Slider/HorizontalSlider'

const StyledPromotionLink = styled(PromotionLink)`
  display: flex;
  align-items: center;
`

const Logo = styled.div`
  min-width: 100px;
  max-width: 170px;
  margin: 0 20px;
`

const PremiumBrandLogoSlider: FC = () => {
  const brandIds = usePremiumPageStore(
    store => store.brandIdsForBrandLogoSlider,
  )

  if (!brandIds || brandIds.length === 0) {
    return null
  }

  return (
    <HorizontalSlider
      disableHeaderControl
      slideCount={5}
      slideCountMedium={6}
      slideCountLarge={7}
      dataTestId="BrandLogoSlider"
    >
      {brandIds.map(id => (
        <BrandLogo key={id} brandId={id} />
      ))}
    </HorizontalSlider>
  )
}

export default PremiumBrandLogoSlider

const BrandLogo: FC<{ brandId: string }> = ({ brandId }) => {
  const { t } = useTranslation()
  const service = useService()
  const brand = service.brands.getByBrandId(brandId)

  if (!brand || !brand.rectangleImageHash) {
    return null
  }

  const logoUrl =
    brand.logoImageHash &&
    cdnImageUrl(brand.logoImageHash, {
      transparent: true,
      width: 400,
      height: 200,
    })
  if (!logoUrl) {
    return null
  }

  return (
    <StyledPromotionLink to={brand.url} data-testid="BrandLogo">
      <Logo>
        <img
          src={logoUrl}
          alt={t('{{brandName}} Logo', { brandName: brand.name })}
        />
      </Logo>
    </StyledPromotionLink>
  )
}
